// chart.js v4 tidak mendaftarkan skala/controller di entry inti; pakai `auto`
// atau Chartkick gagal dengan: "linear" is not a registered scale.
import { Chart } from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Chartkick from 'chartkick'
import 'chartjs-adapter-date-fns'

const READY_FLAG = '__r6DashboardChartkickConfigured'

export function ensureChartkick() {
  if (typeof window !== 'undefined' && window[READY_FLAG] && window.Chartkick) {
    return window.Chartkick
  }

  Chart.register(ChartDataLabels)

  // Habis bertumpuk di atas Selesai; Belum mulai & Sudah mulai tetap kolom terpisah.
  Chart.register({
    id: 'selesaiHabisStackGroups',
    beforeUpdate(chart) {
      const datasets = chart.data && chart.data.datasets
      if (!datasets || datasets.length < 4) return
      const labels = datasets.map((d) => String(d.label || ''))
      if (labels[2] !== 'Selesai' || labels[3] !== 'Habis') return

      datasets.forEach((ds, i) => {
        ds.stack = i <= 1 ? `standalone-${i}` : 'selesai-habis'
      })
      const scales = chart.options && chart.options.scales
      if (scales) {
        if (scales.x) scales.x.stacked = true
        if (scales.y) scales.y.stacked = true
      }
    },
  })

  Chart.defaults.plugins.datalabels = {
    anchor: 'end',
    align: 'top',
    offset: -4,
    color: '#212529',
    font: { weight: '600', size: 11 },
    formatter: (value) => {
      const v = Number(value)
      if (!Number.isFinite(v) || v === 0) return ''
      return String(v)
    },
  }

  Chartkick.use(Chart)

  if (typeof window !== 'undefined') {
    window.Chartkick = Chartkick
    window[READY_FLAG] = true
  }

  return Chartkick
}

ensureChartkick()
